import React from "react";

export default function PrivacyPolicy() {
  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "40px auto",
        padding: "30px",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.6",
      }}
    >
      <h1>Política de Privacidade - Litoral Vips</h1>

      <p>
        <strong>Última atualização:</strong> 10 de setembro de 2026
      </p>

      <p>
        A Litoral Vips respeita a privacidade dos seus usuários e está
        comprometida com a proteção dos dados pessoais utilizados no site
        www.litoralvips.com e no aplicativo Litoral Vips.
      </p>

      <h2>1. Dados coletados</h2>
      <p>
        Poderemos coletar informações como nome, e-mail, telefone, dados de
        cadastro, informações relacionadas às caronas, dados técnicos do
        dispositivo e localização, quando autorizada pelo usuário.
      </p>

      <h2>2. Como utilizamos os dados</h2>
      <p>
        Os dados podem ser utilizados para cadastro, identificação,
        funcionamento da plataforma, solicitação e reserva de caronas,
        atendimento ao usuário, segurança, prevenção de fraudes e melhoria dos
        serviços.
      </p>

      <h2>3. Compartilhamento de dados</h2>
      <p>
        A Litoral Vips não comercializa dados pessoais. Informações poderão ser
        compartilhadas com prestadores de serviços necessários ao funcionamento
        da plataforma ou quando exigido por lei.
      </p>

      <h2>4. Localização</h2>
      <p>
        Quando necessária, a localização será utilizada somente mediante
        permissão do usuário e para funcionalidades relacionadas aos serviços
        oferecidos pela plataforma.
      </p>

      <h2>5. Segurança</h2>
      <p>
        Adotamos medidas destinadas a proteger os dados pessoais contra acesso
        não autorizado, perda, alteração ou uso indevido.
      </p>

      <h2>6. Direitos do usuário</h2>
      <p>
        O usuário poderá solicitar acesso, correção ou exclusão dos seus dados,
        observadas as hipóteses de conservação previstas na legislação.
      </p>

      <h2>7. Exclusão da conta</h2>
      <p>
        O usuário poderá solicitar a exclusão da sua conta e dos dados pessoais
        associados por meio dos canais oficiais da Litoral Vips.
      </p>

      <h2>8. Cookies</h2>
      <p>
        O site poderá utilizar cookies e tecnologias semelhantes para
        funcionamento, segurança e melhoria da experiência do usuário.
      </p>

      <h2>9. Alterações desta política</h2>
      <p>
        Esta Política poderá ser atualizada sempre que necessário. A versão
        mais recente ficará disponível nesta página.
      </p>

      <h2>10. Contato</h2>
      <p>
        Litoral Vips
        <br />
        Site: www.litoralvips.com
      </p>

      <h2>11. Legislação</h2>
      <p>
        Esta Política observa a Lei nº 13.709/2018, Lei Geral de Proteção de
        Dados Pessoais - LGPD.
      </p>
    </div>
  );
}